// src/hooks/useSignOut.js
import { useNavigate } from "react-router-dom";
import { supabase } from "lib/supa";

export default function useSignOut({ redirect = false } = {}) {
  const navigate = useNavigate();

  return async function signOut() {
    await supabase.auth.signOut();
    sessionStorage.removeItem("account_id"); // αν το καθαρίζεις global, μπορείς να το αφαιρέσεις
    if (redirect) {
      navigate("/authentication/sign-in", { replace: true });
    }
  };
}
